import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyLifeState } from '@nk/data-entities-lib';
import { DateFormats } from '@nk/utils-lib';
import { Observable } from 'rxjs';
import { CompanyLifeStateService } from '../../services/company-life-state.service';
import { COMPANY_LIFE_STATE_COLOR_CLASSES } from '../../utils/company-state.utils';

@Component({
  selector: 'nk-company-life-state-badge',
  templateUrl: './company-life-state-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, DatePipe, TranslateModule],
})
export class CompanyLifeStateBadgeComponent implements OnInit {
  public companyUuid = input.required<string>();
  public companyLifeState$: Observable<CompanyLifeState>;
  public readonly colorClasses = COMPANY_LIFE_STATE_COLOR_CLASSES;
  public readonly dateFormats = DateFormats;

  private _companyLifeStateService = inject(CompanyLifeStateService);

  public ngOnInit(): void {
    this.companyLifeState$ = this._companyLifeStateService.getCompanyLifeState(this.companyUuid());
  }
}
